import Service from "../services/base";
import WebSocketChannel from "./webSocketChannel";

export default class NotificationCenter extends Service {
    private readonly webSocketChannel: WebSocketChannel;

    constructor(webSocketChannel: WebSocketChannel) {
        super();
        this.webSocketChannel = webSocketChannel;
    }

    on(topic: string, callback: (data: any) => void) {
        this.webSocketChannel.subscribe(topic, callback);
    }

    off(topic: string) {
        const topicTemplate = topic.replace(/\*.*$/, "");
        const topics = topicTemplate !== topic //using wildcard?
            ? this.webSocketChannel.getSubscriptions().filter(top => top.indexOf(topicTemplate) === 0)
            : [topic];

        topics.forEach(top => this.webSocketChannel.unsubscribe(top));
    }

    offMultiple(topicPatterns: string[]) {
        const allTopics: string[] = [];

        topicPatterns.forEach(topic => {
            const topicTemplate = topic.replace(/\*.*$/, "");
            const topics = topicTemplate !== topic //using wildcard?
                ? this.webSocketChannel.getSubscriptions().filter(top => top.indexOf(topicTemplate) === 0)
                : [topic];

            allTopics.push(...topics);
        });

        // Remove duplicates
        const uniqueTopics = Array.from(new Set(allTopics));

        if (uniqueTopics.length > 0) {
            this.webSocketChannel.unsubscribeMultiple(uniqueTopics);
        }
    }

    subscribed(topic: string): boolean {
        return this.webSocketChannel.getSubscriptions().indexOf(topic) !== -1;
    }

    destroy() {}
}
